var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navPermissions['reports'].enable)?_c("router-link",{tag:"router-link",staticClass:"nav-item",attrs:{"to":"/reports"}},[_c('a',{staticClass:"sidebar-menu-item nav-link"},[[_c('i',{staticClass:"fa fa-file-invoice text-danger pr-2"}),_c('span',{staticClass:"nav-link-text"},[_vm._v("\n                  Reports\n              ")])]],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }